import cls from 'clsx';
import styles from './envBadge.module.css';

// Vite MODE comes from the `--mode` flag used by the deploy workflow, so it
// matches the `.env.*` file names. `development` is the local `pnpm dev` mode.
// `production` is intentionally absent: no badge.
const ENV_LABEL: Record<string, string> = {
  development: 'LOCAL',
  develop: 'DEV',
  develop2: 'DEV',
  testing: 'TESTING',
  staging: 'STAGING'
};

const EnvBadge: React.FC = () => {
  const mode = import.meta.env.MODE;
  const label = ENV_LABEL[mode];

  if (!label) {
    return null;
  }

  return (
    <>
      <span className={cls(styles.strip, styles[mode])} aria-hidden />
      <span className={cls(styles.badge, styles[mode])}>{label}</span>
    </>
  );
};

export default EnvBadge;
